import { useTranslation } from 'react-i18next'
import { Form, useFormikContext } from 'formik'
import { Button, TextField } from '@mui/material'

import { IAccountCreateCheckRespDto, IAccountManualFormCreate } from 'src/types'

import { useStyles } from './styles'
import { AccountExistInfo } from './account-exist-info.component'
import { AddressInput } from '../address-input'
import { HelperWrapper } from '../helper-wrapper'

interface IProps {
  existingAccount: IAccountCreateCheckRespDto
}

export const CreateForm = ({ existingAccount }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const { setFieldValue, values, errors, handleChange, dirty, isSubmitting } =
    useFormikContext<IAccountManualFormCreate>()

  const handleAddressChange = (val: string) => {
    setFieldValue('address', val)
  }

  const submitDisabled = !dirty || !!Object.keys(errors).length || isSubmitting
  return (
    <Form className={classes.form}>
      <>
        <div className={classes.inputsWrapper}>
          <TextField
            autoComplete="off"
            fullWidth
            label={t('account-form-account-holder-input-label.v') + '*'}
            helperText={errors.account_holder && <HelperWrapper t={errors.account_holder} />}
            value={values.account_holder}
            name="account_holder"
            variant="standard"
            FormHelperTextProps={{
              error: !!errors.account_holder,
            }}
            onChange={handleChange}
          />
          <TextField
            autoComplete="off"
            fullWidth
            label={t('email-input-label.v')}
            helperText={errors.email && <HelperWrapper t={errors.email} />}
            value={values.email}
            name="email"
            variant="standard"
            FormHelperTextProps={{
              error: !!errors.email,
            }}
            onChange={handleChange}
          />
          <AddressInput
            error={errors.address}
            value={values.address}
            id="address"
            handleAddress={handleAddressChange}
          />
          <TextField
            autoComplete="off"
            fullWidth
            label={t('account-form-website-input-label.v')}
            helperText={errors.website && <HelperWrapper t={errors.website} />}
            value={values.website}
            name="website"
            variant="standard"
            FormHelperTextProps={{
              error: !!errors.website,
            }}
            onChange={handleChange}
          />
        </div>
        {existingAccount && <AccountExistInfo existingAccount={existingAccount} />}
        <Button disabled={submitDisabled} type="submit">
          <HelperWrapper t="account-form-submit-button" />{' '}
        </Button>
      </>
    </Form>
  )
}
